import styled from 'styled-components'
import theme from 'styles/theme'

const radioButtonOuterWidth = 30
const radioButtonInnerWidth = 6

const FormRadioItem = styled.div`
  padding: ${theme.space[1]} 0;
  width: 100%;
  display: inline-block;

  input[type='radio'] {
    display: none;
    position: relative;

    & + p {
      position: relative;
      display: flex;
      align-items: center;
    }

    & + p:before,
    & + p:after {
      content: '';
      border-radius: 999px;
      display: block;
    }

    & + p:before {
      width: ${radioButtonOuterWidth}px;
      height: ${radioButtonOuterWidth}px;
      border: 1px solid transparent;
      margin-right: ${theme.space[1]};
      transition: background-color 0.25s ease-out, border-color 0.2s ease-out;
      border-color: ${(props) =>
        !props.hasError ? theme.colors.sagelight : theme.colors.red};

      html[dir='rtl'] & {
        margin-right: 0;
        margin-left: ${theme.space[1]};
      }
    }

    & + p:after {
      position: absolute;
      background: red;
      width: ${radioButtonInnerWidth}px;
      height: ${radioButtonInnerWidth}px;
      left: ${(radioButtonOuterWidth - radioButtonInnerWidth) / 2}px;
      top: ${(radioButtonOuterWidth - radioButtonInnerWidth) / 2}px;
      background: ${theme.colors.sagedark};
      transform: scale(0);
      transition: transform 0.25s ease-out;

      html[dir='rtl'] & {
        left: initial;
        right: ${(radioButtonOuterWidth - radioButtonInnerWidth) / 2}px;
      }
    }

    &:checked + p:before {
      background-color: ${theme.colors.sagelight};
      border-color: ${(props) =>
        !props.hasError ? `transparent` : theme.colors.red};
    }
    &:checked + p:after {
      transform: scale(1);
    }
  }
`

export { FormRadioItem as default }
